import React from 'react';

export interface ModalFooterProps {
  message?: React.ReactNode;
  start?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export default function ModalFooter({
  message,
  start,
  children,
  className = 'max-w-5xl mx-auto',
}: ModalFooterProps) {
  return (
    <div
      className="w-full border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-[0_-2px_8px_rgba(0,0,0,0.04)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className={`px-4 py-3 sm:px-6 ${className}`}>
        <div className="flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-between gap-3">
          {(start || message) ? (
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
              {start ? <div className="flex-shrink-0">{start}</div> : null}
              {message ? (
                <p className="text-xs text-amber-700 dark:text-amber-300">
                  {message}
                </p>
              ) : null}
            </div>
          ) : <div />}
          <div className="flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-end gap-2">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
